export enum SummerAppFieldTypesEnum {
    Input="Input",
    Numeric="Numeric Input",
    Dropdown="Dropdown",
    Date="Date Input",
    Checkbox="Checkbox",
    ResumeUpload="Resume Upload",
    SchoolsAutoComplete="Schools Typeahead Input",
    SSN="SSN Field",
    YesNoSelector="Yes/No Selector",
    Label = "Label",
    OptionalInput = "Optional Input"
 }


// WEBPACK FOOTER //
// ./src/app/shared/enums/field-types.enum.ts